export default {
  rolePos: {
    ROLE_IT: '기관 관리자', // 机构管理员
    ROLE_AGENT: '대리 관리자', // 代理管理员
  },
  booleanOptions: {
    YES: '예', // 是
    NO: '아니요', // 否
  },
};
